<div class="my-5">
  <!-- page-header -->
  <sm-page-header [breadcrumb]="breadcrumb" title="settings.companyInfo.new.title" description="settings.companyInfo.new.description"> </sm-page-header>
  <!-- content -->
  <div class="content" *ngIf="!formDateLoading">
    <sm-form-builder [formObject]="formObject" class="w-full px-4"></sm-form-builder>
    <div class="flex justify-end gap-2">
      <p-button [label]="'settings.companyInfo.new.add' | translate" (click)="addCompany()" />
      <p-button [label]="'settings.companyInfo.new.reset' | translate" severity="secondary" />
    </div>
  </div>
  <sm-spinner [loading]="formDateLoading"></sm-spinner>
</div>
